package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2023_04_14_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2023-04-14")
@Composable
public fun Log_2023_04_14(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Repelling the Giant Ambush",
        ogTitle = "Repelling the Giant Ambush",
        date = LocalDate(2_023, 4, 14),
        ogDescription = "The party repels an orc and giant ambush before arriving in Dorb to meet with high-level military officers.",
        ogImage = "ai/2023-04-14.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-23", dateString = "Newgrowth 23")
        Log_2023_04_14_Day_1()
    }
}
